// extracted by mini-css-extract-plugin
module.exports = {"showLink":"TvShow_showLink__xESB0","container":"TvShow_container__1Noth","inner":"TvShow_inner__7bxvC","description":"TvShow_description__zvTBQ"};